export const environment = {
  environment: 'staging',
  production: true,
  enableGA: false,
  customerUrl: 'https://customer-staging.epallet.com',
  vendorUrl: 'https://vendor-staging.epallet.com',
  apiUrl: 'https://erp-staging.epallet.com',
  hmr: false,
  showTours: true,
  enableSentry: true,
  sentryEnv: 'staging',
stripeKey:"pk_test_oBLTJgeLNOMG8d0ZECkSwyBF",
reCaptchaKey:"6Ld7OM8jAAAAAIkO1GHqcxcsXHAUl5nKtOiPdOT5",
sentryDSN:"https://58c2fdebb024a28d6072a7b2ec9497e5@o4505760727433216.ingest.us.sentry.io/4508419110600704",
};